import { post } from '../utils/httpClient'
import { getRedDataApiPaths } from '../config'

export const apiPostCollinsonRedemption = async (rewardId: string) => {
  const body = { rewardId }
  const response = (await post(`${getRedDataApiPaths().RED_API_REDEMPTIONS}`, true, false, body)) as { trackingUrl: string }
  return response
}
